var map = {
	"./cyoa-rover.mp3": 863,
	"./den-gamle-rover-mixed.mp3": 864,
	"./eksplosionen-interview.mp3": 865,
	"./heat-exchanger-log.mp3": 866,
	"./mars-red-moan.m4a": 867,
	"./mars-red-moan.mp3": 868,
	"./motion-paa-mars.mp3": 869,
	"./radiomars-news.mp3": 870,
	"./sciendomus.mp3": 871,
	"./sound-from-bedroom.mp3": 872,
	"./sound-from-kitchen.mp3": 873,
	"./sound-from-office.mp3": 874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 862;